// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ShoppingCartActions } from '../duck';
import ItemCart from '../components/ItemCart/ItemCart';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    isDeletingItem: state.shoppingCart.isDeletingItem,
    editItemError: state.shoppingCart.deleteItemError,
    shoppingCart: state.shoppingCart.shoppingCart,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ShoppingCartActions,
    goToRedirect: (route) => push(route)
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemCart);



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/containers/ItemCartContainer.js